import { createFileRoute } from '@tanstack/react-router';

import { AiMobilePage } from '@/pages/ai/ai-mobile-page';
import { AiPage } from '@/pages/ai/ai-page';
import { useMobile } from '@/shared/lib/use-mobile';
import { validateAiHubSearch } from '@/widgets/ai-activity/use-hub-team';

/**
 * `/ai?team=` — the ✨ AI hub, Assistant tab (Agents and Approvals are the
 * sibling routes, same header). Desktop: chat + history + quick actions;
 * mobile keeps its own page until the conversational sheet ships.
 */
function AiRoute() {
  const isMobile = useMobile();
  return isMobile ? <AiMobilePage /> : <AiPage />;
}

export const Route = createFileRoute('/ai')({
  validateSearch: validateAiHubSearch,
  component: AiRoute,
});
